<template>
    <div class="user-component">
        <div class="user-body">
            <b-form data-vv-scope="lock-semseter-form">
                <b-form-group
                    label="Status"
                    label-for="status"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-select
                        @change="changeStatus(lock_semester_form.status)"
                        v-model="lock_semester_form.status"
                        name="status"
                        data-vv-as="Status"
                        value-field="id"
                        text-field="name"
                        :options="statusList"
                        v-validate="'required'"
                    >
                    <b-form-select-option :value="null" disabled>Pilih Status</b-form-select-option>
                    </b-form-select>
                    <span :class="{ 'error-validation': errors.first('lock-semseter-form.status') }">{{ errors.first('lock-semseter-form.status') }}</span>
                </b-form-group>
                
                <div class="card shadow" v-show="showUser" :class="type === 'dark' ? 'bg-default': ''">
                    <div class="p-2">
                        <ul>
                            <li :id="'listgan_' + index" class="listClose" v-for="(parent, index) in userListt" :key="parent.id">
                                <label>
                                <input type="checkbox" v-model="parent.checked" @change="checkAllChilds(parent)">
                                {{ parent.name }}
                                </label>
                                <span :id="'span1gan_' + index" class="span1 fas fa-chevron-down" @click="openConditionsModal(index)"></span>
                                <ul >
                                <li class="region-child" v-for="(child) in parent.childs" :key="`${parent.id}-${child.id}`">
                                    <label>
                                    <input type="checkbox" v-model="child.checked" @change="checkParentStatus(parent)">
                                    {{ child.name }}
                                    </label>
                                </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveData">SIMPAN</b-button>
        </div>
    </div>
</template>

<style>
    ul {
        list-style-type: none;
        padding-left: 20px;
    }
    button {
        margin-right: 10px;
    }
    .span1 {
        float: right;
        width: 20%;
        margin-top: 4px;
    }
    .listClose > ul {
        display: none;
    }
    .listOpen > ul {
        display: block;
    }
</style>
<script>
    import { mapGetters } from 'vuex'
    import { EventBus } from '@/eventBus.js'
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    // import $ from 'jquery'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
            id: {
                type: String,
                default: null
            },
            statusList: {
                type: Array,
                default () {
                    return [{
                        id:'1',
                        name:'Kunci',
                    },{
                        id:'0',
                        name:'Buka Kunci',
                    },]
                }
            },
            detail: {
                type: Object,
                default () {
                    return {}
                }
            },
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                isBusy: false,
                showLoader: false,
                showUser: this.detail.status==1 ? true : false,
                lock_semester_form: {
                    semester : this.id ? this.detail.semester: null,
                    status : this.id ? this.detail.status: null,
                    class_list : this.id ? this.detail.class_list: [],
                },
                fields: [
                    { key: "selected", label: "", sortable: false },
                    { key: 'id', label: 'ID', sortable: true, class: 'text-right', thClass: 'd-none', tdClass: 'd-none' },
                    { key: 'name', label: 'Name', sortable: true, sortDirection: 'asc', class: 'text-left' },
                ],
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100, 200, 400, 800, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
            };
        },
        mounted() {
            // Set default collapse state for each parent
            this.userListt.forEach(parent => {
                this.$set(parent, 'collapsed', true);
            });
        },
        computed: {
            ...mapGetters({
                userListt: 'getUserHasClassList',
            })
        },
        methods: {
            checkAllChilds(parent) {
                parent.childs.forEach(child => {
                    child.checked = parent.checked;
                });
            },
            checkParentStatus(parent) {
                parent.checked = parent.childs.every(child => child.checked);
            },
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            changeStatus(param) {
                if(param==1){
                    this.showUser = true;
                }else{
                    this.showUser = false;
                }
            },
            openConditionsModal(idx){
                var element = document.getElementById("listgan_"+idx);
                var element1 = document.getElementById("span1gan_"+idx);
                if(element.classList[0]=='listClose'){
                    element.classList.add("listOpen");
                    element.classList.remove("listClose");
                    element1.classList.add("fa-chevron-up");
                    element1.classList.remove("fa-chevron-down");
                }else{
                    element.classList.add("listClose");
                    element.classList.remove("listOpen");
                    element1.classList.add("fa-chevron-down");
                    element1.classList.remove("fa-chevron-up");
                }
            },
            resetForm() {
                // this.lock_semester_form.semester = this.id ? this.detail.semester : null,
                // this.lock_semester_form.status = this.id ? this.detail.status : null,
                // this.lock_semester_form.class_list = this.id ? this.detail.class_list : [],
                // this.$validator.reset()
            },
            hideFormModal() {
                EventBus.$emit('hideFormModal', true)
                this.resetForm()
            },
            async getUserHasClassList() {
                this.isBusy = true
                const lock_id = this.id;
                await this.$store.dispatch('getUserHasClassList',{lock_id})
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
            async saveData() {
                let scope = 'lock-semseter-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.id) {
                            this.lock_semester_form.id = this.id
                            this.update(scope)
                        }
                    }
                });
            },
            async update(scope) {
                this.showLoader = true
                this.lock_semester_form.class_list = this.userListt
                let form = this.lock_semester_form
                // userList
                this.$store.dispatch('updateLockSemester', form)
                    .then((res) => {
                        this.showLoader = false
                        this.$store.dispatch('getLockSemesterList')
                        for(var i=0;i<this.userListt.length;i++){
                            this.userListt[i].checked=false;
                            for(var ij=0;ij<this.userListt[i].childs.length;ij++){
                                this.userListt[i].childs[ij].checked=false;
                            }
                        }
                        this.hideFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
        },
		async created () {
            await this.getUserHasClassList()
			EventBus.$on('resetForm', (val) => {
				if (val) {
					this.resetForm()
				}
			})
        }
    }
</script>